// extracted by mini-css-extract-plugin
export var logoContainer = "NavbarLogo-module--logoContainer--24gor";
export var logoImage = "NavbarLogo-module--logoImage--3IT6J";
export var logoName = "NavbarLogo-module--logoName--3RKTp";
export var link = "NavbarLogo-module--link--3xrKZ";